module.exports = __webpack_public_path__ + "img/portrait.c0c9aca8.jpg";